import React from 'react';
import './Admin.css'
import ButtonsAdmin from '../components/Admin/ButtonsAdmin';
import Box from '@mui/material/Box';
import Grid from '@mui/material/Grid';
import CustomizedTablesAdmin from '../components/Admin/TableAdmin'
import Graphic from '../components/Admin/BarCharts';
import api_data from '../components/data/TableData'

function Admin() {
    const products = api_data['historic']
    const table_sum = api_data['sum_company']

    return (
        <Box>
            <Grid container spacing={1}>
                <Grid item xs={12} sm={12} md={12} lg={4}>
                    <ButtonsAdmin/>
                    {Graphic(products)}
                </Grid>
                <Grid item xs={12} sm={12} md={12} lg={8}>
                    {CustomizedTablesAdmin(table_sum)}
                </Grid>

            </Grid>
        </Box>
    );
}
export default Admin